import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
  MenuItem,
  Chip,
  IconButton,
  Container
} from "@mui/material";

import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";
import "./addQuickConnect.css";
import {
  ArrowDropUp as ArrowDropUpIcon,
  ArrowDropDown as ArrowDropDownIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";

const countryCodes = [
  { label: "Afghanistan (+93)", value: "+93" },
  { label: "Aland Islands (+358)", value: "+358" },
  { label: "Albania (+355)", value: "+355" },
  { label: "Algeria (+213)", value: "+213" },
  { label: "American Samoa (+1)", value: "+1" },
  { label: "Andorra (+376)", value: "+376" },
  { label: "Angola (+244)", value: "+244" },
  { label: "Anguilla (+1)", value: "+1" },
  { label: "Antarctica (+0)", value: "+0" },
  { label: "Antigua And Barbuda (+1)", value: "+1" },
  { label: "Argentina (+54)", value: "+54" },
  { label: "Armenia (+374)", value: "+374" },
  { label: "Aruba (+297)", value: "+297" },
  { label: "Ascension Island (+247)", value: "+247" },
  { label: "Australia (+61)", value: "+61" },
  { label: "Austria (+43)", value: "+43" },
  { label: "Azerbaijan (+994)", value: "+994" },
  { label: "Bahamas (+1)", value: "+1" },
  { label: "Bahrain (+973)", value: "+973" },
  { label: "Bangladesh (+880)", value: "+880" },
  { label: "Barbados (+1)", value: "+1" },
  { label: "Belarus (+375)", value: "+375" },
  { label: "Belgium (+32)", value: "+32" },
  { label: "Belize (+501)", value: "+501" },
  { label: "Benin (+229)", value: "+229" },
  { label: "Bermuda (+1)", value: "+1" },
  { label: "Bhutan (+975)", value: "+975" },
  { label: "Bolivia (+591)", value: "+591" },
  { label: "Bosnia And Herzegovina (+387)", value: "+387" },
  { label: "Botswana (+267)", value: "+267" },
  { label: "Bouvet Island (+0)", value: "+0" },
  { label: "Brazil (+55)", value: "+55" },
  { label: "British Indian Ocean Territory (+246)", value: "+246" },
  { label: "Brunei Darussalam (+673)", value: "+673" },
  { label: "Bulgaria (+359)", value: "+359" },
  { label: "Burkina Faso (+226)", value: "+226" },
  { label: "Burundi (+257)", value: "+257" },
  { label: "Cambodia (+855)", value: "+855" },
  { label: "Cameroon (+237)", value: "+237" },
  { label: "Canada (+1)", value: "+1" },
  { label: "Cape Verde (+238)", value: "+238" },
  { label: "Cayman Islands (+1)", value: "+1" },
  { label: "Central African Republic (+236)", value: "+236" },
  { label: "Chad (+235)", value: "+235" },
  { label: "Chile (+56)", value: "+56" },
  { label: "China (+86)", value: "+86" },
  { label: "Christmas Island (+61)", value: "+61" },
  { label: "Cocos (Keeling) Islands (+61)", value: "+61" },
  { label: "Colombia (+57)", value: "+57" },
  { label: "Comoros (+269)", value: "+269" },
  { label: "Congo (+242)", value: "+242" },
  { label: "Congo, Democratic Republic (+243)", value: "+243" },
  { label: "Cook Islands (+682)", value: "+682" },
  { label: "Costa Rica (+506)", value: "+506" },
  { label: "Cote D'Ivoire (+225)", value: "+225" },
  { label: "Croatia (+385)", value: "+385" },
  { label: "Cuba (+53)", value: "+53" },
  { label: "Curacao (+599)", value: "+599" },
  { label: "Cyprus (+357)", value: "+357" },
  { label: "Czech Republic (+420)", value: "+420" },
  { label: "Denmark (+45)", value: "+45" },
  { label: "Diego Garcia (+0)", value: "+0" },
  { label: "Djibouti (+253)", value: "+253" },
  { label: "Dominica (+1)", value: "+1" },
  { label: "Dominican Republic (+1)", value: "+1" },
  { label: "Ecuador (+593)", value: "+593" },
  { label: "Egypt (+20)", value: "+20" },
  { label: "El Salvador (+503)", value: "+503" },
  { label: "Equatorial Guinea (+240)", value: "+240" },
  { label: "Eritrea (+291)", value: "+291" },
  { label: "Estonia (+372)", value: "+372" },
  { label: "Ethiopia (+251)", value: "+251" },
  { label: "Falkland Islands (+500)", value: "+500" },
  { label: "Faroe Islands (+298)", value: "+298" },
  { label: "Fiji (+679)", value: "+679" },
  { label: "Finland (+358)", value: "+358" },
  { label: "France (+33)", value: "+33" },
  { label: "French Guiana (+594)", value: "+594" },
  { label: "French Polynesia (+689)", value: "+689" },
  { label: "French Southern Territories (+0)", value: "+0" },
  { label: "Gabon (+241)", value: "+241" },
  { label: "Gambia (+220)", value: "+220" },
  { label: "Georgia (+995)", value: "+995" },
  { label: "Germany (+49)", value: "+49" },
  { label: "Ghana (+233)", value: "+233" },
  { label: "Gibraltar (+350)", value: "+350" },
  { label: "Greece (+30)", value: "+30" },
  { label: "Greenland (+299)", value: "+299" },
  { label: "Grenada (+1)", value: "+1" },
  { label: "Guadeloupe (+590)", value: "+590" },
  { label: "Guam (+1)", value: "+1" },
  { label: "Guatemala (+502)", value: "+502" },
  { label: "Guernsey (+44)", value: "+44" },
  { label: "Guinea (+224)", value: "+224" },
  { label: "Guinea-Bissau (+245)", value: "+245" },
  { label: "Guyana (+592)", value: "+592" },
  { label: "Haiti (+509)", value: "+509" },
  { label: "Heard Island & Mcdonald Islands (+0)", value: "+0" },
  { label: "Holy See (Vatican City State) (+39)", value: "+39" },
  { label: "Honduras (+504)", value: "+504" },
  { label: "Hong Kong (+852)", value: "+852" },
  { label: "Hungary (+36)", value: "+36" },
  { label: "Iceland (+354)", value: "+354" },
  { label: "India (+91)", value: "+91" },
  { label: "Indonesia (+62)", value: "+62" },
  { label: "Iran, Islamic Republic Of (+98)", value: "+98" },
  { label: "Iraq (+964)", value: "+964" },
  { label: "Ireland (+353)", value: "+353" },
  { label: "Isle Of Man (+44)", value: "+44" },
  { label: "Israel (+972)", value: "+972" },
  { label: "Italy (+39)", value: "+39" },
  { label: "Jamaica (+1)", value: "+1" },
  { label: "Japan (+81)", value: "+81" },
  { label: "Jersey (+44)", value: "+44" },
  { label: "Jordan (+962)", value: "+962" },
  { label: "Kazakhstan (+7)", value: "+7" },
  { label: "Kenya (+254)", value: "+254" },
  { label: "Kiribati (+686)", value: "+686" },
  { label: "Korea (+82)", value: "+82" },
  { label: "Kuwait (+965)", value: "+965" },
  { label: "Kyrgyzstan (+996)", value: "+996" },
  { label: "Lao People's Democratic Republic (+856)", value: "+856" },
  { label: "Latvia (+371)", value: "+371" },
  { label: "Lebanon (+961)", value: "+961" },
  { label: "Lesotho (+266)", value: "+266" },
  { label: "Liberia (+231)", value: "+231" },
  { label: "Libyan Arab Jamahiriya (+218)", value: "+218" },
  { label: "Liechtenstein (+423)", value: "+423" },
  { label: "Lithuania (+370)", value: "+370" },
  { label: "Luxembourg (+352)", value: "+352" },
  { label: "Macao (+853)", value: "+853" },
  { label: "Macedonia (+389)", value: "+389" },
  { label: "Madagascar (+261)", value: "+261" },
  { label: "Malawi (+265)", value: "+265" },
  { label: "Malaysia (+60)", value: "+60" },
  { label: "Maldives (+960)", value: "+960" },
  { label: "Mali (+223)", value: "+223" },
  { label: "Malta (+356)", value: "+356" },
  { label: "Marshall Islands (+692)", value: "+692" },
  { label: "Martinique (+596)", value: "+596" },
  { label: "Mauritania (+222)", value: "+222" },
  { label: "Mauritius (+230)", value: "+230" },
  { label: "Mayotte (+262)", value: "+262" },
  { label: "Mexico (+52)", value: "+52" },
  { label: "Micronesia, Federated States Of (+691)", value: "+691" },
  { label: "Moldova (+373)", value: "+373" },
  { label: "Monaco (+377)", value: "+377" },
  { label: "Mongolia (+976)", value: "+976" },
  { label: "Montenegro (+382)", value: "+382" },
  { label: "Montserrat (+1)", value: "+1" },
  { label: "Morocco (+212)", value: "+212" },
  { label: "Mozambique (+258)", value: "+258" },
  { label: "Myanmar (+95)", value: "+95" },
  { label: "Namibia (+264)", value: "+264" },
  { label: "Nauru (+674)", value: "+674" },
  { label: "Nepal (+977)", value: "+977" },
  { label: "Netherlands (+31)", value: "+31" },
  { label: "Netherlands Antilles (+0)", value: "+0" },
  { label: "New Caledonia (+687)", value: "+687" },
  { label: "New Zealand (+64)", value: "+64" },
  { label: "Nicaragua (+505)", value: "+505" },
  { label: "Niger (+227)", value: "+227" },
  { label: "Nigeria (+234)", value: "+234" },
  { label: "Niue (+683)", value: "+683" },
  { label: "Norfolk Island (+672)", value: "+672" },
  { label: "Northern Mariana Islands (+1)", value: "+1" },
  { label: "Norway (+47)", value: "+47" },
  { label: "Oman (+968)", value: "+968" },
  { label: "Pakistan (+92)", value: "+92" },
  { label: "Palau (+680)", value: "+680" },
  { label: "Palestinian Territory, Occupied (+970)", value: "+970" },
  { label: "Panama (+507)", value: "+507" },
  { label: "Papua New Guinea (+675)", value: "+675" },
  { label: "Paraguay (+595)", value: "+595" },
  { label: "Peru (+51)", value: "+51" },
  { label: "Philippines (+63)", value: "+63" },
  { label: "Pitcairn (+0)", value: "+0" },
  { label: "Poland (+48)", value: "+48" },
  { label: "Portugal (+351)", value: "+351" },
  { label: "Puerto Rico (+1)", value: "+1" },
  { label: "Qatar (+974)", value: "+974" },
  { label: "Reunion (+262)", value: "+262" },
  { label: "Romania (+40)", value: "+40" },
  { label: "Russian Federation (+7)", value: "+7" },
  { label: "Rwanda (+250)", value: "+250" },
  { label: "Saint Barthelemy (+590)", value: "+590" },
  { label: "Saint Helena (+290)", value: "+290" },
  { label: "Saint Kitts And Nevis (+1)", value: "+1" },
  { label: "Saint Lucia (+1)", value: "+1" },
  { label: "Saint Martin (+590)", value: "+590" },
  { label: "Saint Pierre And Miquelon (+508)", value: "+508" },
  { label: "Saint Vincent And Grenadines (+1)", value: "+1" },
  { label: "Samoa (+685)", value: "+685" },
  { label: "San Marino (+378)", value: "+378" },
  { label: "Sao Tome And Principe (+239)", value: "+239" },
  { label: "Saudi Arabia (+966)", value: "+966" },
  { label: "Senegal (+221)", value: "+221" },
  { label: "Serbia (+381)", value: "+381" },
  { label: "Seychelles (+248)", value: "+248" },
  { label: "Sierra Leone (+232)", value: "+232" },
  { label: "Singapore (+65)", value: "+65" },
  { label: "Sint Maarten (+1)", value: "+1" },
  { label: "Slovakia (+421)", value: "+421" },
  { label: "Slovenia (+386)", value: "+386" },
  { label: "Solomon Islands (+677)", value: "+677" },
  { label: "Somalia (+252)", value: "+252" },
  { label: "South Africa (+27)", value: "+27" },
  { label: "South Georgia And Sandwich Isl. (+0)", value: "+0" },
  { label: "South Sudan (+211)", value: "+211" },
  { label: "Spain (+34)", value: "+34" },
  { label: "Sri Lanka (+94)", value: "+94" },
  { label: "Sudan (+249)", value: "+249" },
  { label: "Suriname (+597)", value: "+597" },
  { label: "Svalbard And Jan Mayen (+47)", value: "+47" },
  { label: "Swaziland (+268)", value: "+268" },
  { label: "Sweden (+46)", value: "+46" },
  { label: "Switzerland (+41)", value: "+41" },
  { label: "Syrian Arab Republic (+963)", value: "+963" },
  { label: "Taiwan (+886)", value: "+886" },
  { label: "Tajikistan (+992)", value: "+992" },
  { label: "Tanzania (+255)", value: "+255" },
  { label: "Thailand (+66)", value: "+66" },
  { label: "Timor-Leste (+670)", value: "+670" },
  { label: "Togo (+228)", value: "+228" },
  { label: "Tokelau (+690)", value: "+690" },
  { label: "Tonga (+676)", value: "+676" },
  { label: "Trinidad And Tobago (+1)", value: "+1" },
  { label: "Tunisia (+216)", value: "+216" },
  { label: "Turkey (+90)", value: "+90" },
  { label: "Turkmenistan (+993)", value: "+993" },
  { label: "Turks And Caicos Islands (+1)", value: "+1" },
  { label: "Tuvalu (+688)", value: "+688" },
  { label: "Uganda (+256)", value: "+256" },
  { label: "Ukraine (+380)", value: "+380" },
  { label: "United Arab Emirates (+971)", value: "+971" },
  { label: "United Kingdom (+44)", value: "+44" },
  { label: "United States (+1)", value: "+1" },
  { label: "United States Outlying Islands (+0)", value: "+0" },
  { label: "Uruguay (+598)", value: "+598" },
  { label: "Uzbekistan (+998)", value: "+998" },
  { label: "Vanuatu (+678)", value: "+678" },
  { label: "Venezuela (+58)", value: "+58" },
  { label: "Viet Nam (+84)", value: "+84" },
  { label: "Virgin Islands, British (+1)", value: "+1" },
  { label: "Virgin Islands, U.S. (+1)", value: "+1" },
  { label: "Wallis And Futuna (+681)", value: "+681" },
  { label: "Western Sahara (+212)", value: "+212" },
  { label: "Yemen (+967)", value: "+967" },
  { label: "Zambia (+260)", value: "+260" },
  { label: "Zimbabwe (+263)", value: "+263" },
  { label: "Wales (+0)", value: "+0" },
  { label: "Scotland (+0)", value: "+0" },
  { label: "England (+0)", value: "+0" },
  { label: "Catalonia (+0)", value: "+0" }
];

const AddQuickConnectPage = ({ onClose, onProfileAdded }) => {
  const [profileName, setProfileName] = useState("");
  const [description, setDescription] = useState("");
  const [connectType, setConnectType] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [flow, setFlow] = useState("");
  const [searchQueue, setSearchQueue] = useState("");
  const [queueFlow, setQueueFlow] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [tags, setTags] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);
  const [actionClicked, setActionClicked] = useState(null);
  const [queueList, setQueueList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [showTags, setShowTags] = useState(false);
const [countryIndex, setCountryIndex] = useState('');

  // Local storage values
  const instanceId = localStorage.getItem("InstanceId");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  const instanceAlias = localStorage.getItem("instanceName");

  const toggleShowTags = () => setShowTags((prev) => !prev);

  // Fetch queue list
  const fetchQueueList = async () => {
    const payload = {
      Action: "listQueues",
      ID: instanceId,
      awsAccount: customerAWSAccountId,
      region: region
    };

    try {
      const response = await axiosInstance.post(
        endpoints.displayQueuelist.quickQueue,
        payload
      );

      const parsedBody = JSON.parse(response.data.body);
      if (parsedBody && Array.isArray(parsedBody)) {
        const extractedData = parsedBody.map((item) => ({
          queueName: item
        }));
        console.log("Fetched QuickQueue:", extractedData);
        return extractedData;
      } else {
        console.error("Unexpected response format:", parsedBody);
        return [];
      }
    } catch (error) {
      console.error("Fetch error:", error.response?.data || error.message);
      return [];
    }
  };

  // Fetch user list
  const fetchQuickConnectUsers = async () => {
    const payload = {
      Action: "listUsers",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      InstanceAlias: instanceAlias,
      region: "us-west-2",
    };

    try {
      const response = await axiosInstance.post(
        endpoints.listquickConnectUser.listUsers,
        payload
      );

      const parsedBody = JSON.parse(response.data.body);
      if (Array.isArray(parsedBody)) {
        return parsedBody.map((user) => ({ userName: user }));
      } else {
        console.error("Unexpected user list response:", parsedBody);
        return [];
      }
    } catch (error) {
      console.error("Fetch Users Error:", error.response?.data || error.message);
      return [];
    }
  };

  const fetchQuickConnects = async () => {
  const payload = {
    Action: "list",
    ID: EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region,
    InstanceAlias: instanceAlias,
  };

  try {
    const res = await axiosInstance.post(
      endpoints.displayquickConnects.quickConnects,
      payload
    );

    const rawBody = res?.data?.body;
    if (!rawBody) {
      console.warn("QuickConnects: response body is undefined or empty");
      return [];
    }

    let parsed;
    try {
      parsed = JSON.parse(rawBody);
    } catch (err) {
      console.error("Failed to parse QuickConnects JSON:", err);
      return [];
    }

    const dataArray = Array.isArray(parsed)
      ? parsed
      : parsed.QuickConnects || parsed.quickConnects || [];

    const extractedData = dataArray.map((item) => {
  const config = item.QuickConnectConfig || {};

  return {
    quickConnectARN: item.QuickConnectARN,
    quickConnectId: item.QuickConnectId,
    name: item.Name,
    description: item.Description || "",
    quickConnectType: config.QuickConnectType || "",

    // ✅ Prefer names when IDs are missing
    queueId: config.QueueConfig?.QueueId || "",
    queueName: item.QueueName || config.QueueConfig?.QueueName || "—",

    userId: config.UserConfig?.UserId || "",
    userName: item.UserName || config.UserConfig?.UserName || "—",

    contactFlowId:
      config.QueueConfig?.ContactFlowId ||
      config.UserConfig?.ContactFlowId ||
      "",
    contactFlowName:
      item.ContactFlowName ||
      config.QueueConfig?.ContactFlowName ||
      config.UserConfig?.ContactFlowName ||
      "—",

    phoneNumber: config.PhoneConfig?.PhoneNumber || "—",

    tags: item.Tags || {},
    lastModifiedTime: item.LastModifiedTime || "",
    lastModifiedRegion: item.LastModifiedRegion || "",
  };
})

    console.log("📊 Extracted Quick Connects:", extractedData);
    return extractedData;
  } catch (error) {
    console.error("Error fetching quick connects:", error);
    return [];
  }
};

// Load data on component mount
  useEffect(() => {
    const loadData = async () => {
      const queues = await fetchQueueList();
      const users = await fetchQuickConnectUsers();

      if (queues && Array.isArray(queues)) {
        setQueueList(queues);
      }

      if (users && Array.isArray(users)) {
        setUserList(users);
      }
    };

    loadData();
  }, []);

  const formatTagsForPayload = (tagArray) =>
    tagArray.reduce((acc, tag) => {
      acc[tag.key] = tag.value;
      return acc;
    }, {});

  const handleAddTag = () => {
    if (key && value) {
      setTags((prev) => [...prev, { key, value }]);
      setKey("");
      setValue("");
    }
  };

  const handleDeleteTag = (index) => {
    setTags((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCancel = () => {
    setActionClicked("cancel");
    setCancelButtonLoading(true);
    setTimeout(() => {
      setCancelButtonLoading(false);
      setActionClicked(null);
      onClose();
    }, 300);
  };

  const AddQuickProfiles = async () => {
  const newErrors = {
    profileName: !profileName,
    connectType: !connectType,
    searchUser: connectType === "User" && !searchUser,
    flow: connectType === "User" && !flow,
    searchQueue: connectType === "Queue" && !searchQueue,
    queueFlow: connectType === "Queue" && !queueFlow,
    countryCode: connectType === "PhoneNumber" && !countryCode,
    phoneNumber: connectType === "PhoneNumber" && !phoneNumber,
  };

  setErrors(newErrors);

  const hasError = Object.values(newErrors).some(Boolean);
  if (hasError) return;

  setActionClicked("save");
  setLoading(true);

  const payload = {
    Action: "create",
    ID: EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region,
    Name: profileName,
    Description: description,
    InstanceAlias: instanceAlias,
    Tags: formatTagsForPayload(tags),
    connectType,
    QuickConnectConfig: {
      ...(connectType === "User" && {
        UserConfig: {
          UserName: searchUser,
          ContactFlowName: flow,
        },
      }),
      ...(connectType === "Queue" && {
        QueueConfig: {
          QueueName: searchQueue,
          ContactFlowName: queueFlow,
        },
      }),
      ...(connectType === "PhoneNumber" && {
        PhoneConfig: {
          PhoneNumber: `${countryCode}${phoneNumber}`,
        },
      }),
    },
  };

  console.log("➕ Add Quick Connect Payload:", payload);

  try {
    const createResponse = await axiosInstance.post(
      endpoints.displayquickConnects.quickConnects,
      payload
    );

    console.log("📡 Create Response:", createResponse);

    if (createResponse.status === 200) {
      console.log("✅ Quick connect created successfully");

      // 🔄 CRITICAL FIX: Wait a bit longer and ensure proper data fetching
      setTimeout(async () => {
        try {
          console.log("🔄 Fetching updated quick connects list...");
          const updatedList = await fetchQuickConnects();
          
          console.log("📊 Fetched updated list:", updatedList);
          
          if (updatedList && Array.isArray(updatedList)) {
            console.log("✅ Sending updated list to parent:", updatedList);
            onProfileAdded(updatedList); // 🔄 This should trigger table update
          } else {
            console.warn("⚠️ Failed to fetch updated list after creation");
            // 🔄 Even if fetch fails, try to close gracefully
            onClose();
          }
        } catch (fetchError) {
          console.error("❌ Error fetching updated list:", fetchError);
          alert("Quick Connect created but failed to refresh the list. Please refresh the page.");
          onClose();
        } finally {
          setLoading(false);
          setActionClicked(null);
        }
      }, 500); // 🔄 Increased delay to ensure backend processing
    } else {
      throw new Error(`Create failed with status: ${createResponse.status}`);
    }
  } catch (error) {
    console.error("❌ Error adding quick connect:", error);
    alert("Error while creating quick connect: " + (error.response?.data?.message || error.message));
    setLoading(false);
    setActionClicked(null);
  }
};

  return (
    <div className="addhour-navbar-container">
      <Container className="addhour-content-container">
        <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
          <IconButton
            onClick={onClose}
            size="medium"
            sx={{
              border: "1px solid #ccc",
              borderRadius: "50%",
              padding: 1,
              bgcolor: "#f5f5f5",
              "&:hover": { bgcolor: "#e0e0e0" }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" className="phone-text">
            Add Quick Connect
          </Typography>
        </Box>

        <Box className="form-section">
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
            width="100%"
          >
            <TextField
              fullWidth
              label="Name"
              required
              value={profileName}
              onChange={(e) => setProfileName(e.target.value)}
              error={errors.profileName}
              helperText={errors.profileName && "Profile name is required"}
              className="security-form-field"
            />

            <TextField
              fullWidth
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="security-form-field"
            />
          </Box>

          <TextField
            select
            fullWidth
            label="Type"
            value={connectType}
            onChange={(e) => setConnectType(e.target.value)}
            error={!!errors.connectType}
            helperText={errors.connectType ? "Select a type" : ""}
            className="security-form-field"
          >
            <MenuItem value="User">User</MenuItem>
            <MenuItem value="Queue">Queue</MenuItem>
            <MenuItem value="PhoneNumber">Phone Number</MenuItem>
          </TextField>

          {/* User Type Fields */}
          {connectType === "User" && (
            <Box
              display="flex"
              gap={2}
              flexDirection={{ xs: "column", sm: "row" }}
              width="100%"
            >
              <TextField
                select
                fullWidth
                label="Search User"
                value={searchUser}
                onChange={(e) => setSearchUser(e.target.value)}
                error={errors.searchUser}
                helperText={errors.searchUser && "Select a user"}
              >
                {userList.map((user, idx) => (
                  <MenuItem key={idx} value={user.userName}>
                    {user.userName}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                fullWidth
                label="Flows"
                value={flow}
                onChange={(e) => setFlow(e.target.value)}
                error={errors.flow}
                helperText={errors.flow && "Select a flow"}
              >
                <MenuItem value="Default agent transfer">Default agent transfer</MenuItem>
              </TextField>
            </Box>
          )}

          {/* Queue Type Fields */}
          {connectType === "Queue" && (
            <Box
              display="flex"
              gap={2}
              flexDirection={{ xs: "column", sm: "row" }}
              width="100%"
            >
              <TextField
                select
                fullWidth
                margin="normal"
                label="Search Queue"
                value={searchQueue}
                onChange={(e) => setSearchQueue(e.target.value)}
                error={errors.searchQueue}
                helperText={errors.searchQueue && "Select a queue"}
              >
                {queueList.map((queue, index) => (
                  <MenuItem key={index} value={queue.queueName}>
                    {queue.queueName}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                fullWidth
                margin="normal"
                label="Flows"
                value={queueFlow}
                onChange={(e) => setQueueFlow(e.target.value)}
                error={errors.queueFlow}
                helperText={errors.queueFlow && "Select a flow"}
              >
                <MenuItem value="Default queue transfer">Default queue transfer</MenuItem>
              </TextField>
            </Box>
          )}

          {/* Phone Number Fields */}
          {connectType === "PhoneNumber" && (
            <Box display="flex" gap={2} mt={2}>
              <TextField
  select
  sx={{ minWidth: 200 }}
  label="Country Code"
  value={countryIndex}
  onChange={(e) => {
    setCountryIndex(e.target.value);
    setCountryCode(countryCodes[e.target.value].value);
  }}
  error={!!errors.countryCode}
  helperText={errors.countryCode && "Select a country code"}
>
  {countryCodes.map((country, index) => (
    <MenuItem 
      key={index} 
      value={index} // Use index as value
    >
      {country.label}
    </MenuItem>
  ))}
</TextField>

              <TextField
                fullWidth
                label="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                error={!!errors.phoneNumber}
                helperText={errors.phoneNumber && "Phone number required"}
              />
            </Box>
          )}

          {/* Tags Section */}
          <Box className="addqueue-tags-container">
            <Box
              className="addqueue-tags-toggle"
              onClick={toggleShowTags}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ mt: -2}}
            >
              <Typography className="addqueue-showtext-tags">
                Show advanced settings

    <IconButton className="addqueue-arrow-button">
      {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
    </IconButton>
        </Typography>
  </Box>

  {/* Conditional render of tags only when expanded */}
  {showTags && (
    <>
      <Typography className="addqueue-tagheading">Tags (Optional)</Typography>
      <Typography className="paratext">
        You can add resource tags for organization & access control.
      </Typography>

      <Box className="addqueue-input-container">
        <TextField
          label="Key"
          placeholder="key"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          className="addqueue-input-field"
        />
        <TextField
          label="Value"
          placeholder="value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="addqueue-input-field"
          disabled={!key}
        />
        <Button
          variant="outlined"
          onClick={handleAddTag}
          disabled={!key || !value}
        >
          Add
        </Button>
      </Box>

      {tags.length > 0 && (
        <Box mt={1}>
          <Typography variant="subtitle2">Selected Tags</Typography>
          <Box display="flex" flexWrap="wrap" gap={1}>
            {tags.map((tag, index) => (
              <Chip
                key={index}
                label={`${tag.key}: ${tag.value}`}
                onDelete={() => handleDeleteTag(index)}
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  )}
</Box>

      </Box>

      {/* Buttons */}
      <Box className="buttons-addhour">
        <Button
          onClick={handleCancel}
          disabled={actionClicked === "save" || cancelButtonLoading}
                           >
                             {actionClicked === "cancel" ? <CircularProgress size={18} /> : "Cancel"}
                    </Button>
        <Button onClick={AddQuickProfiles} variant="contained"
                   disabled={actionClicked === "cancel" || loading}
                       >
                         <span className="adduser-button-content">
                           {actionClicked === "save" ? (
                             <CircularProgress size={18} style={{ color: "white" }} />
                           ) : (
                             "Save"
                           )}
                           </span>
                  </Button>
      </Box>
    </Container>
    </div>
  );
};

export default AddQuickConnectPage;
